export default "__VITE_ASSET__tBAippYc__"